import React, { Component } from 'react';

class HeadlineDatePicker extends Component {
    render() {
        return (
            <h2 className="headline headline--two" onClick={this.props.onClick}>
                {this.props.value}
            </h2>
        );
    }
}

export default HeadlineDatePicker;



// WEBPACK FOOTER //
// ./src/components/ui/headline-datepicker.js